const USER_GROUPS = [
    {name: 'admin', value: 1},
    {name: 'hitfm', value: 2},
    {name: 'dfm', value: 3},
    {name: 'rusradio', value: 4},
    {name: 'maximum', value: 5},
    {name: 'montecarlo', value: 6},
    {name: 'rutv', value: 7},
]

export { USER_GROUPS }